import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchDailyReport = createAsyncThunk(
  'report/fetchDaily',
  async ({ empId, date }, { rejectWithValue }) => {
    try {
      return await api.getDailyReport(empId, { date });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchWeeklyReport = createAsyncThunk(
  'report/fetchWeekly',
  async ({ empId, weekStart }, { rejectWithValue }) => {
    try {
      return await api.getWeeklyReport(empId, { week_start: weekStart });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMonthlyReport = createAsyncThunk(
  'report/fetchMonthly',
  async ({ empId, year, month }, { rejectWithValue }) => {
    try {
      return await api.getMonthlyReport(empId, { year, month });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const reportSlice = createSlice({
  name: 'report',
  initialState: {
    daily: null,
    weekly: null,
    monthly: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearReports: (state) => {
      state.daily = null;
      state.weekly = null;
      state.monthly = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDailyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.daily = action.payload;
      })
      .addCase(fetchDailyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchWeeklyReport.fulfilled, (state, action) => {
        state.weekly = action.payload;
      })
      .addCase(fetchMonthlyReport.fulfilled, (state, action) => {
        state.monthly = action.payload;
      });
  },
});

export const { clearReports, clearError } = reportSlice.actions;
export default reportSlice.reducer;
